import { useMemo } from 'react';
import {
  ACTIVE_ASSAILANT_ALERT_TYPE,
  TRAIN_INCIDENT_ALERT_TYPE,
} from '@rsos/constants/alertTypes';
import { mockAlertToastsSettings } from '../../mock';

export const UPDATE_SETTINGS_ERROR =
  'Some changes may not have been saved. Please try again.';

export const disabledAlertTypes = [
  ACTIVE_ASSAILANT_ALERT_TYPE,
  TRAIN_INCIDENT_ALERT_TYPE,
];

/**
 * Certain alert types unconditionally have toasts/banners, thus those checkboxes are always cheched and disabled
 * @param {String} name -The alert type name.
 * @returns Boolean
 */

export const getIsCheckboxDisabled = name => {
  return disabledAlertTypes.includes(name);
};

/**
 * Diff mock alert types with available alert types coming from andromeda before saving the new settings
 * @param {Object} alertTypes - default or previously saved alert types used to prefil the form
 * @param {Object} availableAlertTypes - Enabled alert types capabilities coming from Andromeda.
 * @returns Object - new settings correlated to andromeda enabled alert types
 */

export const filterAlertTypesByCapabilities = (
  alertTypes,
  availableAlertTypes,
) => {
  const availableNames = availableAlertTypes.map(a => a.name);
  return Object.fromEntries(
    Object.entries(alertTypes).filter(([key]) => availableNames.includes(key)),
  );
};

/**
 * Fetch initial values for Formik
 * @param {Object} alertTypes - alert types
 * @returns Array - enabled form values
 */

export const getCheckboxValues = alertTypes => {
  let formValues = [];
  Object.values(alertTypes).forEach(type => {
    if (type.enabled) {
      formValues = [...formValues, type.name];
    }
  });
  return formValues;
};

export const useMigratedAlerts = settings => {
  return useMemo(() => {
    const rawTypes = settings?.alert_types;
    if (!rawTypes) return {};

    const masterDefinitions = mockAlertToastsSettings.alert_types;

    const migratedEntries = Object.entries(rawTypes).map(([key, value]) => {
      if (!value || !value.name) {
        const staticData = masterDefinitions[key];

        return [
          key,
          {
            ...(staticData || {}),
            ...value,
          },
        ];
      }

      return [key, value];
    });

    return Object.fromEntries(migratedEntries);
  }, [settings]);
};
